import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Directive,
  Host,
  Inject,
  Input,
  OnDestroy,
  OnInit
} from '@angular/core';
import { FieldType } from '@app/shared/constants';
import { Subject, Subscription } from 'rxjs';
import { DataTableNewComponent } from '../data-table-new.component';
import { DataTableState } from '../state/state.model';
import { StateService } from '../state/state.service';

export interface SearchFilter {
  name: string;
  type: FieldType;
}

@Directive({ selector: '[vfsDatatableSearch]', exportAs: 'vfsDatatableSearch' })
export class DatatableSearchDirective implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy {
  @Input() searchEnabled = true;
  stateId: string;
  stateChangeSubject$: Subject<DataTableState>;

  searchInputChangeSubscription: Subscription;

  constructor(
    @Host() private parent: DataTableNewComponent<any>,
    @Inject('StateService') private stateService: StateService,
    private cdRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.stateId = this.parent.stateId;
    this.stateChangeSubject$ = this.parent.stateChangeSubject$;
    this.parent.withSearch = this.searchEnabled;
  }

  ngAfterViewInit() {
    if (this.parent.searchInput) {
      const state: DataTableState = this.stateService.get(this.stateId);

      this.parent.searchInput.inputRef.nativeElement.value = state.filter.search;
      this.searchInputChangeSubscription = this.parent.searchInput.change.subscribe((value: string) => {
        const currentState: DataTableState = this.stateService.get(this.stateId);
        currentState.filter.search = value;
        currentState.page.index = 0;

        this.stateService.update(currentState);

        this.stateChangeSubject$.next(currentState);
      });
    }
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  ngOnDestroy() {
    if (this.searchInputChangeSubscription) {
      this.searchInputChangeSubscription.unsubscribe();
    }
  }

  cleanSearch() {
    this.parent.searchInput.inputRef.nativeElement.value = '';
  }
}
